import { isSearchIndexingBlocked } from "../config/searchIndexing";
import { pagesSEO } from "./pages";
import { SEO_RULES_BY_KIND } from "./standards/kindRules";
import { PAGE_SEO_KIND_BY_KEY } from "./standards/pageSeoKindByKey";
import type { IResolvedPageSEO, ISEOProps, TPageSEOKey } from "./types/core";

export function resolvePageSeo(
  page: TPageSEOKey,
  overrides?: Partial<ISEOProps>
): IResolvedPageSEO {
  const base = pagesSEO[page];
  const merged: ISEOProps = {
    ...base,
    ...overrides,
  };
  const pageKind = PAGE_SEO_KIND_BY_KEY[page];
  const rules = SEO_RULES_BY_KIND[pageKind];
  const indexingBlocked = isSearchIndexingBlocked();
  const robots = indexingBlocked ? "noindex,nofollow" : rules.robots;

  return {
    ...merged,
    pageKind,
    robots,
    openGraphType: rules.openGraphType,
    twitterCard: rules.twitterCard,
    canonicalDropTrackingParams: rules.canonicalDropTrackingParams,
  };
}
